import { TextField, Select, menuItemClasses, MenuItem } from '@mui/material';
import { TestRunStatusTypes, TestcasesExecutionStatus } from '../../enums/TestrunStatusEnum';
import ModalWrapper from '../Modal/modalWrapper/basicModalWrapper';
import axios from '../../api/axiosInstance';
import { useSnackbar } from '../../utils/useSnackbar';

const CreateTestRunModal = ({ isOpen, onClose, onError, onCreate }) => {
  const { showSnackbar } = useSnackbar();

  const handleConfirmAdd = async (data) => {
    try{
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/testrun/create`, {
     data
    }, {
      validateStatus: function (status) {
        return status < 500; // Resolve only if the status code is less than 500
      }
    });

    if (response.status <200 || response.status >= 300) {
      showSnackbar(response?.data?.message || 'Error: Failed to create test run', 'error');
      return;
    }
    onCreate(response.data);
    onClose();
    } catch (error) {
      console.error('Error creating Testrun:', error);
      showSnackbar(error.response?.data?.message || "Failed to create test run", "error");
    }
  };
  
  const buttons = [
    {
      label: 'Cancel',
      variant: 'outlined',
      onClick: onClose,
    },
    {
      label: 'Create',
      variant: 'contained',
      color: 'primary',
    },
  ];

  const fields = [
    {
      Component: TextField,
      label: 'Name',
      name: 'name',
      required: true,
      autoFocus: true,
      fullWidth: true,
    },
    {
      Component: TextField,
      name: 'description',
      label: 'Description',
      multiline: true,
      rows: 3,
      autoFocus: false,
      fullWidth: true,
    },
    // {
    //   Component: Select, 
    //   name: 'status',
    //   inputLabel: 'Status',
    //   required: true,
    //   fullWidth: true,
    //   //defaultValue: '', 
    //   options: Object.entries(TestcasesExecutionStatus).map(([key, value]) => ({
    //     value: value, // e.g., 'completed', 'inprogress'
    //     label: value, // e.g., 'Completed', 'In Progress'
    //   })),
    // },
    {
  Component: TextField,
  label: 'Start Date',
  name: 'startDate',
  required: true,
  type: 'date',
  fullWidth: true,
  InputLabelProps: { shrink: true },
  rules: {
    validate: (value, formValues) => {
      if (!value || !formValues.endDate) return true;
      
      // Normalize dates by setting time to start of day
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      
      const start = new Date(value);
      start.setHours(0, 0, 0, 0);
      
      const end = new Date(formValues.endDate);
      end.setHours(0, 0, 0, 0);

      if(today > start) {
        return 'Start Date must be after or equal to Today';
      }
      if (end < start) {
        return 'Start Date must be before or equal to End Date';
      }
      return true;
    }
  }
},
{
  Component: TextField,
  label: 'End Date',
  name: 'endDate',
  required: true,
  type: 'date',
  fullWidth: true,
  InputLabelProps: { shrink: true },
  rules: {
      validate: (value, formValues) => {
        if (!value || !formValues.startDate) return true;

        // Normalize dates by setting time to start of day
        const start = new Date(formValues.startDate);
        start.setHours(0, 0, 0, 0);
        
        const end = new Date(value);
        end.setHours(0, 0, 0, 0);

        if (end < start) {
          return 'End Date must be after or equal to Start Date';
        }
        return true;
      },
    },
},

  ]

  return (
    <ModalWrapper
      open={isOpen}
      onClose={onClose}
      title="Add New Test Run"
      fields={fields}
      buttons={buttons}
      onSubmit={handleConfirmAdd}
      containerStyles={{
        //height: "90vh", // Custom height
        // width: "60%", // Custom width
      }}
      initialValues={{
        name: '',
        description: '',
        //status: '',
        startDate: '',
        endDate: '',
      }}
    />
  );
};

export default CreateTestRunModal;